import {auth_getAuthenticatedUser_Api, refreshTokenApi} from 'apis'
import history from 'envs/_current/history'
import {getTokenKey, setTokenKey} from 'helpers/localStorage'
import localforage from 'localforage'
import {callApi} from 'modules/asyncCache/callApi'
import {call, fork, put, take, takeLatest} from 'redux-saga/effects'
import {emptyObject} from '../../helpers/emptyObjects'
import * as types from '../types'
import {loginFailure, loginSuccess} from './actions'
import {IS_CORDOVA} from "../../envs/_current/config";
import {clearPersistedAuth} from "../../helpers/authPersist";


function* loginAsync() {
    try {
        const data = yield call(callApi, {
            apiInfo: auth_getAuthenticatedUser_Api,
        }) || emptyObject;
        switch (data?.status) {
            case 200:
                // if (!!data?.data?.id) {
                    yield put(
                        loginSuccess({
                            user: data.data,
                            token: getTokenKey(),
                        })
                    )
                // } else {
                //     console.log('ERROR: loginFailure()')
                //     yield put(loginFailure())
                // }
                break
            case 400:
            case 401:
                yield put({
                    type: types.REQUEST_REFRESH_TOKEN,
                })
                break
            case 404:
                if (
                    (!!data.data &&
                        !!data.data.error &&
                        data.data.error === 'user_not_found') ||
                    (!!data.error && data.error === 'user_not_found')
                ) {
                    // force logout
                    yield put({type: 'LOGOUT'})
                }
                break
            case 500:
                if (!!data.error &&
                    !!data.data &&
                    !!data.data.message &&
                    data.data.message === 'Unauthenticated.') {
                    yield put({type: 'LOGOUT'})
                }
                break
            default:
                console.log('ERROR: loginFailure()')
                yield put(loginFailure())
                break
        }
    } catch (error) {
        yield put(loginFailure())
    }
}

function* login() {
    yield takeLatest('LOGIN', loginAsync)
}

function* refreshTokenAsync() {
    try {
        const results = yield call(refreshTokenApi)
        console.log('refreshTokenApi:', results)
        if (results.status === 200) {
            const token = results.data.token
            setTokenKey(token)
            yield put({
                type: types.UPDATE_REFRESH_TOKEN,
                token,
            })
        } else {
            yield put({
                type: types.CHECK_AUTHENTICATE_FAIL,
                results,
            })
            yield put({type: 'LOGOUT'})
        }
    } catch (error) {
        console.error(error)
        yield put({
            type: types.CHECK_AUTHENTICATE_FAIL,
            error,
        })
        yield put({type: 'LOGOUT'})
    }
}

function* refreshToken() {
    yield takeLatest(types.REQUEST_REFRESH_TOKEN, refreshTokenAsync)
}

function* logoutAsync() {
    try {
        if (typeof window !== 'undefined') {
            yield window.localStorage.removeItem("_wTokenKey")
            clearPersistedAuth()
        }
    } catch (e) {}

    try {
        // Chỉ xóa các key liên quan đến cache/feed, KHÔNG clear toàn bộ
        // localforage.clear() sẽ xóa luôn redux-persist → màn hình trắng
        const keysToRemove = ['feedCache', 'rankedFeed'] // thêm key nào cần xóa
        for (const key of keysToRemove) {
            yield localforage.removeItem(key)
        }
    } catch (e) {}

    // try {
    //     saveLanguageKey('vi')
    // } catch (e) {}

    if (IS_CORDOVA) {
        if (window.plugins && window.plugins.googleplus) {
            window.plugins.googleplus.logout(function (msg) {})
        }
    }

    try {
        const path = IS_CORDOVA ? './' : '/'
        history.push(path)
    } catch (e) {}
}

function* logout() {
    yield takeLatest('LOGOUT', logoutAsync)
}

function* reset() {
    const {payload} = yield take('RESET')
    yield put({type: 'LOGOUT'})
    if (payload?.redirect_url) {
        history.replace(payload.redirect_url)
    }
}

export default [fork(login), fork(refreshToken), fork(logout), fork(reset)]
